import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { useRoute, useRouter } from "vue-router";
import { ElLoading, ElMessage } from "element-plus";
import { GetPreviewPaperApi } from "@/api/examApi.js";
import { nextTick, reactive, ref, watch } from "vue";
import { audioUrl } from "@/env.js";
import MenuBox from "@/components/exam/MenuBox.vue";
import sequencing from "@/components/examItem/item-sequencing.vue";
import mcq from "@/components/examItem/item-mcq.vue";
import saq from "@/components/examItem/item-saq.vue";
import pwco from "@/components/examItem/item-pwco";
import proofreading from "@/components/examItem/item-proofreading";
import mm from "@/components/examItem/item-mm.vue";
import oral from "@/components/examItem/item-oral.vue";
import mm_sequencing from "@/components/examItem/item-mm-sequencing.vue";
import mm_drag from "@/components/examItem/item-mm-drag.vue";
import mm_mcq from "@/components/examItem/item-mm-mcq.vue";
import mcq_mmcq from "@/components/examItem/item-mcq-mmcq.vue";
import writing from "@/components/examItem/item-writing.vue";
import writing_listen from "@/components/examItem/item-writing-listen.vue";
import vocabulary_mcq from "@/components/examItem/item-vocabulary-mcq.vue";
import { useStore } from "vuex";
export default {
  components: {
    writing,
    writing_listen,
    mm,
    mm_sequencing,
    mcq_mmcq,
    mm_drag,
    mm_mcq,
    proofreading,
    pwco,
    MenuBox,
    mcq,
    sequencing,
    saq,
    oral,
    vocabulary_mcq
  },
  setup() {
    let route = useRoute();
    let router = useRouter();
    let paperInfo = reactive({});
    let itemNo = ref(0);
    let store = useStore();
    let cache = reactive({
      answers: {}
    });
    function getPaper(id) {
      if (!id) return 0;
      const loading = ElLoading.service({
        lock: true,
        text: "加载中..",
        background: "rgba(0, 0, 0, 0.7)"
      });
      GetPreviewPaperApi(id).then(r => {
        loading.close();
        if (r.status < 400) {
          Object.assign(paperInfo, r.data);
          if (paperInfo.items[0].itemAttributeList[0].itemAttributeValue.length > 2) {
            paperInfo.skill = store.state.skillText[paperInfo.items[0].itemAttributeList[0].itemAttributeValue];
          } else {
            paperInfo.skill = paperInfo.items[0].itemAttributeList[0].itemAttributeValue;
          }
          useSettingPaper(paperInfo, 3);
        } else {
          ElMessage({
            type: "error",
            showClose: true,
            message: r.msg
          });
        }
      });
    }
    //目录
    function useSettingPaper(paperInfo) {
      let task = 1;
      paperInfo.items.forEach(items => {
        items.skill = paperInfo.skill;
        items.menu = task;
        let mark = 0;
        items.questionGroupList.forEach(group => {
          group.questionList.forEach(questionItem => {
            if (questionItem.questionScore) {
              task++;
              questionItem.menuMark = mark;
              mark++;
            }
          });
        });
        //mm的分类
        if (items.questionGroupList[0].questionMethod == "mm") {
          //选择题展示
          if (items.questionGroupList[0].questionList[0].questionStem.split(" ").length > 2) {
            items.questionGroupList[0].questionMethod = "mm-mcq";
          } else if (items.questionGroupList[0].choiceList[0].choiceText.split(" ").length > 1) {
            items.questionGroupList[0].questionMethod = "mm-drag";
          }
        } else if (items.questionGroupList[0].questionMethod == "mcq") {
          items.questionGroupList.forEach(questionItem => {
            if (questionItem.choiceList.length == 2) {
              questionItem.questionMethod = "judge";
            }
          });
        }
      });
    }
    function pwcoAnswer(text) {
      let str = "";
      let wordList = paperInfo.items[itemNo.value].questionGroupList[0].questionList[0].questionPrompt.split("#");
      let pwcoList = text.split("##");
      pwcoList.forEach(item => {
        let numList = item.slice(item.indexOf("[") + 1, -1);
        str += item.slice(0, item.indexOf("["));
        for (let i = 0; i < numList.length; i++) {
          if (!isNaN(numList[i])) {
            str += `[${wordList[numList[i] - 1]}]`;
          } else {
            str += numList[i];
          }
        }
        str += ".  ";
      });
      return str;
    }
    let {
      audioStatus,
      audioPlay,
      audioEnded
    } = useAudio(itemNo);
    function setAnswer(msg) {
      for (let key in msg) {
        cache.answers[key] = msg[key];
      }
    }
    getPaper(route.query.paperid);
    return {
      pwcoAnswer,
      setAnswer,
      cache,
      audioUrl,
      route,
      router,
      getPaper,
      paperInfo,
      itemNo,
      audioStatus,
      audioPlay,
      audioEnded
    };
  }
};

//播放器
function useAudio(itemNo) {
  let audioStatus = ref("loading");
  let audioTimer;
  //播放
  function audioPlay() {
    //当前题目
    let audio = document.getElementById("audio");
    //获取播放时间
    nextTick(() => {
      audio.play();
      audioStatus.value = "ing";
    });
  }
  //播放结束
  function audioEnded() {
    clearInterval(audioTimer);
    audioStatus.value = "over";
  }
  //更换题目时，更新播放状态
  watch(itemNo, () => {
    //更改状态
    audioStatus.value = "loading";
    nextTick(() => {
      setLoading();
    });
  }, {
    immediate: true
  });
  function setLoading() {
    let audio = document.getElementById("audio");
    if (audio) {
      audio.pause();
      audio.load();
    } else {
      setTimeout(() => {
        setLoading();
      }, 1000);
    }
  }
  return {
    audioStatus,
    audioPlay,
    audioEnded
  };
}